import { Theme } from '@material-ui/core/styles';

// ----------------------------------------------------------------------

export default function Menu(theme: Theme, containerId: string) {
  return {
    MuiMenuItem: {
      defaultProps: {
        container: document.getElementById(containerId),
      },
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: theme.palette.action.selected,
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },
          },
        },
      },
    },
  };
}
